import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import ZoneService from "../../../../../services/ZoneService";
import ParkingSlotsService from "../../../../../services/ParkingSlotsService";

const AddParkingSlotsModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		zone: "",
		floor: "",
		note: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const [floorsOptions, setFloorsOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const zoneService = new ZoneService();
	const parkingSlotsService = new ParkingSlotsService();

	useEffect(() => {
		Promise.all([zoneService?.getList()]).then((res) => {
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
						floor: Number(info?.floor),
					};
				});
				setZonesOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					name_en: item?.name_en,
					name_ar: item?.name_ar,
					zone: {
						label: lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar,
						value: item?.zone_id,
					},
					floor: {
						label: item?.floor_number,
						value: item?.floor_number,
					},
					note: item?.note || "",
				});
			}
		});
	}, []);

	useEffect(() => {
		if (!!formData?.zone?.value) {
			const result = Array.from({ length: formData?.zone?.floor }, (_, i) => ({
				label: i + 1,
				value: i + 1,
			}));
			setFloorsOptions(result);
		}
	}, [formData?.zone]);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.zone?.value || !formData?.floor?.value) {
			toast.error("Complete All Phases");
			return;
		}
		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			zone_id: formData?.zone?.value,
			floor_number: `${formData?.floor?.value}`,
		};
		if (formData?.note) data["note"] = formData?.note;

		setLoading(true);
		if (isAdd) {
			parkingSlotsService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			parkingSlotsService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.parking_slot}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} {Translate[lang]?.english}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) =>
									setFormData({
										...formData,
										name_en: e.target.value,
									})
								}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} {Translate[lang]?.arabic}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.arabic}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) =>
									setFormData({
										...formData,
										name_ar: e.target.value,
									})
								}
							/>
						</Col>
						{/* Zone */}
						<Col md={12} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.zone}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) => setFormData({ ...formData, zone: e })}
							/>
						</Col>
						{/* Floor */}
						<Col md={12} className="mb-3">
							<label>
								{Translate[lang]?.floor}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.floor}
								name="floor"
								noOptionsMessage={() =>
									`${Translate[lang]?.select} ${Translate[lang]?.zone} ${Translate[lang]?.first}`
								}
								placeholder={Translate[lang]?.select}
								options={floorsOptions}
								onChange={(e) => setFormData({ ...formData, floor: e })}
							/>
						</Col>
						{/* Note */}
						<Col md={12}>
							<label className="d-block mb-2">{Translate[lang]?.note}</label>
							<textarea
								placeholder={Translate[lang]?.note}
								name="note"
								value={formData?.note}
								className="w-100"
								style={{
									border: "1px solid #dedede",
									minHeight: "80px",
									borderRadius: "10px",
									padding: "16px",
								}}
								onChange={(e) =>
									setFormData({
										...formData,
										note: e.target.value,
									})
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.parking_slot}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddParkingSlotsModal;
